// Cookies are blocked by default.
// User allows cookies by interacting with the site (scrolling or clicking).
// This is stored in a cookie, and in database if the user is logged in.

var cwCookieBar = {
  temporary_disable_cookie_name: 'temporary_disable_cookies',
  dont_show_bar_again_cookie_name: 'dont_show_cookie_bar_again',
  scroll_timeout: 2000,
  fade_time: 1000,

  should_show_bar: function() {
    return false;
    return (!this.dont_show_cookie_bar_again() && !jQuery('body').hasClass('frontpage') && typeof(AB) != 'undefined' && AB.test('cookiestatement-popup') == 'B');
  },

  update_user_options: function(cookies_disabled) {
  },

  cookies_disabled_for_user: function() {
    return false;
  },

  dont_show_cookie_bar_again: function() {
    return true;
  },

  set_user_cookie_disable: function(param) {
  },

  attach_close_events: function() {
  },

  show_bar: function() {
  },

  hide_bar: function() {
  },

  accept_cookies: function() {
  }
}

// Global function being called in cached templates... :(
function disable_cookies_for_user() {
}

// For backward compatibility with v1 and v2
function update_user_cookie_options(cookies_disabled) {
}
